import { Button } from "primereact/button";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import UpdateGateForm from "./UpdateGateForm";

function UpdateGate({ data, getAllGates }) {
  const [showModal, setShowModal] = useState(false);
  if (data === null) {
    return null;
  }
  const onCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <Button
        icon="pi pi-pencil"
        onClick={() => setShowModal(true)}
        className="p-button-rounded p-button-warning p-mr-2"
      />
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        <UpdateGateForm
          formData={data}
          onCloseModal={onCloseModal}
          getAllGates={getAllGates}
        />
      </Dialog>
    </>
  );
}

export default UpdateGate;
